<template>
  <v-card flat color="#2B3D50" dark>
    <v-card-text>
      <v-autocomplete
        v-model="select"
        :loading="loading"
        :items="items"
        :search-input.sync="search"
        cache-items
        flat
        hide-no-data
        hide-details
        label="What are your commands? "
        clearable
        color="primary"
        outlined
        height="100px"
        @keyup="onEnterKeyUp"
      ></v-autocomplete>
    </v-card-text>
    <v-alert
      v-if="tokens && tokens.length > 0"
      color="primary darken-1"
      icon="mdi-check-decagram"
    >Your commad is VALID!</v-alert>
    <v-alert
      v-if="tokens && tokens.length == 0"
      color="red lighten-3"
      icon="mdi-cancel"
    >Your commad is INVALID!</v-alert>
    <v-list color="#2B3D50" dark>
      <v-list-item>
        <v-select
          v-if="accounts"
          v-model="selectedAccountId"
          :items="accounts"
          item-text="name"
          item-value="id"
          label="Select an Account"
          hide-details
          flat
          hide-no-data
          color="primary"
          outlined
        ></v-select>
        <v-spacer />
        <v-btn
          :loading="sending"
          class="mx-3"
          x-large
          outlined
          primary
          :disabled="!tokens || tokens.length ==0 || !selectedAccountId"
          @click="send(select, selectedAccountId)"
        >SEND</v-btn>
        <v-btn icon x-large outlined primary :loading="reloading" @click="reload">
          <v-icon>cached</v-icon>
        </v-btn>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import ApiService from "@/common/api.service";
import getTemplate from "@/components/terminals/CommandTemplate.js";
import { mapGetters } from "vuex";
import { ACCOUNT, COMMAND } from "@/store/actions.type";

export default {
  name: "TerminalEditorBar",
  components: {
    // JSONView
  },
  props: {
    traderAccountId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      reloading: false,
      sending: false,
      items: [],
      search: null,
      select: null,
      tokens: null,
      selectedAccountId: this.traderAccountId || null,
      templates: getTemplate()
    };
  },
  computed: {
    ...mapGetters(["commands", "currentUser", "accounts"])
  },
  watch: {
    currentUser(v) {
      this.fetchCommands(v.id);
      this.fetchAccounts(v.id);
    },
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
    select(v) {
      this.lexer(v);
    }
  },
  mounted() {},
  methods: {
    fetchCommands(userId) {
      if (this.commands == undefined || this.commands == null) {
        this.$store.dispatch(COMMAND.FETCH, userId);
      }
    },
    fetchAccounts(userId) {
      if (this.accounts == undefined || this.accounts == null) {
        this.$store.dispatch(ACCOUNT.FETCH, userId);
      }
    },
    querySelections(v) {
      this.loading = true;
      // Simulated ajax query
      this.items = [];
      setTimeout(() => {
        let history = this.commands.filter(e => {
          return (
            (e.cmdMessage || "")
              .toLowerCase()
              .indexOf((v || "").toLowerCase()) > -1
          );
        });
        let foundTemplates = this.templates.filter(e => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        if (history.length == 0 && foundTemplates.length == 0) {
          this.items.push(this.search);
        } else {
          let foundHistory = [];
          history.forEach(element => {
            foundHistory.push(element.cmdMessage);
          });
          this.items = [...foundTemplates, ...foundHistory, ...[this.search]];
        }
        this.loading = false;
      }, 500);
    },
    lexer(val) {
      if (val && this.search) {
        val = val.replace("{{", "").replace("}}", "");
        let json = {
          code: val,
          commands: []
        };
        // set header to authorize
        ApiService.setHeader().then(() => {
          // fetch terminals
          ApiService.post("terminals/webapp", json).then(result => {
            this.tokens = result.data.commands;
          });
        });
      } else {
        this.tokens = null;
      }
    },
    send(code, traderAccountId) {
      this.sending = true;
      // add {{ code }}
      let json = {
        code: code, // "{{ " + code + " }}",
        commands: []
      };
      // set header to authorize
      ApiService.setHeader().then(() => {
        // fetch terminals
        ApiService.post(
          `terminals/webapp?traderAccountId=${traderAccountId}`,
          json
        )
          .then(result => {
            // console.log(result.data);
            this.tokens = result.data.commands;
          })
          .finally(() => {
            this.sending = false;
          });
      });
    },
    onEnterKeyUp(v) {
      if (v.code == "Enter" && v.ctrlKey == false) {
        this.select = this.search;
      }
    },
    jsonViewData(data) {
      if (data && data.length > 0) {
        if (data[0].command) {
          return data[0].command;
        } else {
          return data;
        }
      }
    },
    reload() {
      this.reloading = true;
      this.$store
        .dispatch(COMMAND.FETCH, this.currentUser.id)
        .then(() => (this.reloading = !this.reloading));
    }
  }
};
</script>
<style scoped>
.customize {
  --vjc-key-color: white;
  --vjc-valueKey-color: white;
  --vjc-string-color: white;
  --vjc-number-color: white;
  --vjc-boolean-color: white;
  --vjc-null-color: white;
  --vjc-arrow-size: 6px;
  --vjc-arrow-color: white;
}
.customize.dark {
  --vjc-valueKey-color: white;
}
</style>